module.exports = __webpack_public_path__ + "static/media/s_v8_t9.92510faf.mp3";